module.exports = __webpack_public_path__ + "static/media/download_icon.776a5c80.svg";